import React, { Component } from "react";
import SearchBar from "./../components/SearchBar";
import SearchResults from "./../components/SearchResults";
import { fetchSearchResults } from "./../api/SearchResultsFetcher";
import PaginationBuilder from "./../../../../common/PaginationBuilder";

export default class SearchContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: {
        organizations: [],
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 10
      },
      paginationConfig: {
        serverSidePagination: true,
        itemsPerPage: 10,
        pageRangeDisplayed: 5
      },
      pageNumber: 1,
      searchText: "",
      receivedSearchResponse: false
    };
    this.paginator = React.createRef();
  }

  componentDidMount() {
    console.log("in SearchContainer componentDidMount");
  }

  resetSearchResults = () => {
    console.log("in resetSearchResults");
    this.setState({ searchResults: {} });
  };

  performSearch = searchText => {
    console.log("in performSearch");
    return fetchSearchResults(searchText, this.state.pageNumber).then(data =>
      this.setState({
        searchResults: data,
        searchText: searchText,
        receivedSearchResponse: true
      })
    );
  };

  refreshPage = pageNumber => {
    console.log("in refreshPage");

    return fetchSearchResults(this.state.searchText, pageNumber).then(data =>
      this.setState({
        searchResults: data,
        pageNumber: pageNumber,
        receivedSearchResponse: true
      })
    );
  };

  render() {
    return (
      <div>
        <SearchBar
          performSearch={this.performSearch}
          resetSearchResults={this.resetSearchResults}
          information="Search for the organization and then select the org to view Net Promoter Score points"
        />
        {this.state.searchResults.organizations &&
          this.state.searchResults.organizations.length > 0 && (
            <div>
              <SearchResults
                searchResults={this.state.searchResults}
                searchText={this.state.searchText}
              />
              <PaginationBuilder
                key="paginationBuilder"
                ref={this.paginator}
                totalItems={this.state.searchResults.totalRecords}
                serverSidePagination={
                  this.state.paginationConfig.serverSidePagination
                }
                refreshPage={this.refreshPage}
                itemsPerPage={this.state.paginationConfig.itemsPerPage}
                url=""
                pageRangeDisplayed={
                  this.state.paginationConfig.pageRangeDisplayed
                }
              />
            </div>
          )}

        {this.state.receivedSearchResponse &&
          this.state.searchResults.organizations &&
          this.state.searchResults.organizations.length === 0 && (
            <div id="noResults">No records found.</div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/firstnet/search/organization/containers/SearchContainer.js